import type { RevenueAnalyticsFilterColumn, RevenueAnalyticsRowsPerPage, RevenueAnalyticsSortColumn } from './types';
import type { RevenueAnalyticsColumnKey } from 'src/admin/LAB/RevenueAnalytics/columns';

export type RevenueAnalyticsAction =
    | { type: 'SET_FIRM'; firmId: string | undefined }
    | { type: 'SELECT_PROVIDER'; providerId: string }
    | { type: 'SET_PAGE'; page: number }
    | { type: 'SET_ROWS_PER_PAGE'; rowsPerPage: RevenueAnalyticsRowsPerPage }
    | { type: 'TOGGLE_SORT'; column: RevenueAnalyticsSortColumn }
    | { type: 'SET_COLUMN_FILTER'; column: RevenueAnalyticsFilterColumn; value: string }
    | { type: 'CLEAR_COLUMN_FILTERS' }
    | { type: 'TOGGLE_COLUMN_VISIBILITY'; column: RevenueAnalyticsColumnKey }
    | { type: 'RESET_COLUMN_VISIBILITY' }
    | { type: 'SET_SYMBOL_SEARCH_INPUT'; value: string }
    | { type: 'APPLY_SYMBOL_SEARCH' }
    | { type: 'CLEAR_SYMBOL_SEARCH' }
    | { type: 'START_CSV_DOWNLOAD' }
    | { type: 'FAIL_CSV_DOWNLOAD' }
    | { type: 'END_CSV_DOWNLOAD' };

// Initializes the firm scope on a fresh instance; the model enforces
// that the scope never changes afterwards (the owning route creates a
// new model per firm).
export const setFirm = (firmId: string | undefined): RevenueAnalyticsAction => ({
    type: 'SET_FIRM',
    firmId,
});

export const selectProvider = (providerId: string): RevenueAnalyticsAction => ({ type: 'SELECT_PROVIDER', providerId });

export const setPage = (page: number): RevenueAnalyticsAction => ({ type: 'SET_PAGE', page });

export const setRowsPerPage = (rowsPerPage: RevenueAnalyticsRowsPerPage): RevenueAnalyticsAction => ({
    type: 'SET_ROWS_PER_PAGE',
    rowsPerPage,
});

export const toggleSort = (column: RevenueAnalyticsSortColumn): RevenueAnalyticsAction => ({
    type: 'TOGGLE_SORT',
    column,
});

export const setColumnFilter = (column: RevenueAnalyticsFilterColumn, value: string): RevenueAnalyticsAction => ({
    type: 'SET_COLUMN_FILTER',
    column,
    value,
});

export const clearColumnFilters = (): RevenueAnalyticsAction => ({ type: 'CLEAR_COLUMN_FILTERS' });

export const toggleColumnVisibility = (column: RevenueAnalyticsColumnKey): RevenueAnalyticsAction => ({
    type: 'TOGGLE_COLUMN_VISIBILITY',
    column,
});

export const resetColumnVisibility = (): RevenueAnalyticsAction => ({ type: 'RESET_COLUMN_VISIBILITY' });

export const setSymbolSearchInput = (value: string): RevenueAnalyticsAction => ({
    type: 'SET_SYMBOL_SEARCH_INPUT',
    value,
});

export const applySymbolSearch = (): RevenueAnalyticsAction => ({ type: 'APPLY_SYMBOL_SEARCH' });

export const clearSymbolSearch = (): RevenueAnalyticsAction => ({ type: 'CLEAR_SYMBOL_SEARCH' });

export const startCsvDownload = (): RevenueAnalyticsAction => ({ type: 'START_CSV_DOWNLOAD' });

export const failCsvDownload = (): RevenueAnalyticsAction => ({ type: 'FAIL_CSV_DOWNLOAD' });

export const endCsvDownload = (): RevenueAnalyticsAction => ({ type: 'END_CSV_DOWNLOAD' });
